module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nif(!(storage.request.queryParams || {}).TEXT_MODE){\nconst title = storage.__('events.registration.applicantAuthMail.eventLink.title')\n%><%- storage.__('events.registration.applicantAuthMail.intro') %><a class=\"eventLink\" href=\"{{eventLink}}\" alt=\"<%= title %>\"><%- title %> &gt;&gt;</a><br><br><br><%\n} else {\n%>\n<%- storage.__('events.registration.applicantAuthMail.intro').replace(/\\<br\\>/gi, \"\\n\") %>\n{{eventLink}}<%\n}\n%>"
  , __filename = "components\\templates\\events\\applicantAuthLink.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if(!(storage.request.queryParams || {}).TEXT_MODE){
const title = storage.__('events.registration.applicantAuthMail.eventLink.title')

    ; __line = 4
    ; __append( storage.__('events.registration.applicantAuthMail.intro') )
    ; __append("<a class=\"eventLink\" href=\"{{eventLink}}\" alt=\"")
    ; __append(escapeFn( title ))
    ; __append("\">")
    ; __append( title )
    ; __append(" &gt;&gt;</a><br><br><br>")
    ; 
} else {

    ; __line = 6
    ; __append("\n")
    ; __line = 7
    ; __append( storage.__('events.registration.applicantAuthMail.intro').replace(/\<br\>/gi, "\n") )
    ; __append("\n{{eventLink}}")
    ; __line = 8
    ; 
}

    ; __line = 10
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components\templates\events\applicantAuthLink.ejs

}